// extracted by mini-css-extract-plugin
export default {"heading":"column-list-nav-module__heading--mX7KT","leadingVisual":"column-list-nav-module__leadingVisual--1qHse"};